module.exports = __webpack_public_path__ + "py.svg?3cccc8b3d9d9cf5a11a939a950181023";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/py.svg
// module id = 1168
// module chunks = 27